import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify"; // Importar react-toastify
import "react-toastify/dist/ReactToastify.css"; // Importar los estilos de toastify

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // Función para añadir un producto al carrito
  const addToCart = (product) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.id === product.id);
      let updatedCart;
      if (existingItem) {
        updatedCart = prevItems.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        updatedCart = [...prevItems, { ...product, quantity: 1 }];
      }
      // Guardar el carrito actualizado en localStorage
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      toast.success(`${product.name} agregado al carrito!`); // Mostrar mensaje de éxito
      return updatedCart;
    });
  };

  // Función para eliminar o disminuir cantidad de un producto
  const removeFromCart = (product, removeCompletely = false) => {
    setCartItems((prevItems) => {
      let updatedCart;
      if (removeCompletely) {
        updatedCart = prevItems.filter((item) => item.id !== product.id);
        toast.info(`${product.name} eliminado del carrito.`);
      } else {
        updatedCart = prevItems
          .map((item) =>
            item.id === product.id
              ? { ...item, quantity: Math.max(item.quantity - 1, 0) }
              : item
          )
          .filter((item) => item.quantity > 0);
        toast.warn(`Cantidad de ${product.name} reducida.`);
      }
      localStorage.setItem("cart", JSON.stringify(updatedCart));
      return updatedCart;
    });
  };

  const clearCart = () => {
    setCartItems([]);
    localStorage.removeItem("cart");
    toast.error("Carrito vaciado.");
  };

  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartItems));
  }, [cartItems]);

  return (
    <CartContext.Provider
      value={{ cartItems, addToCart, removeFromCart, clearCart, cartCount }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
